import React, { useRef, useState } from 'react';
import { compiler } from 'markdown-to-jsx';
import cls from 'classnames';

import styles from './index.module.sass';

const trimString = ( string: string, max?: number ) => {
  // trim the string to the maximum length
  let trimmedString = string.substr( 0, max );

  // re-trim if we are in the middle of a word
  trimmedString = trimmedString.substr(
    0,
    Math.min( trimmedString.length, trimmedString.lastIndexOf( ' ' ))
  );

  return trimmedString;
};

interface MarkdownWithReadMoreProps {
  max?: number;
  readmoreClassName?: string;
  text: string;
  onViewMore?: () => void;
}

export const MarkdownWithReadMore = ({
  max,
  readmoreClassName,
  text,
  onViewMore,
}: MarkdownWithReadMoreProps ) => {
  const [ open, setOpen ] = useState( false );
  const textElem = useRef();

  if ( !text ) return null;

  const overflowText = max && text.length > max ? text.substring( max, -1 ) : null;

  const handleClick = () => {
    setOpen( true );

    if ( onViewMore ) onViewMore();
  };

  return (
    <div className="position-relative overflow-hidden h-auto" ref={textElem}>
      {open || !overflowText ? (
        compiler( text, { forceInline: true })
      ) : (
        <>
          {compiler( trimString( text, max ), { forceInline: true })}
          &hellip;{' '}
          <button
            type="button"
            className={cls(
              'btn btn-sm btn-link p-0 stretched-link',
              styles.readMore,
              readmoreClassName
            )}
            onClick={handleClick}
          >
            Read More
          </button>
        </>
      )}
    </div>
  );
};
